import { MobileCommMessageTable } from "../MobileCommMessageTable";
import { DataSource, HorizontalSpacer, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommSendMessage extends Layout {
	horizontalspacer1: HorizontalSpacer;
	horizontalspacer2: HorizontalSpacer;
	layoutMobileCommMessageTable: MobileCommMessageTable;
	panel1: Panel;
	panel2: Panel;
	panelSpacer: Panel;
	sourceMcMessage: DataSource;
	switchReceipt: Switch;
	switchRequestReply: Switch;
	textboxDeliveryPriority: Textbox;
	textboxMessage: Textbox;
	textboxUnit: Textbox;
}
